import { useParams } from 'react-router-dom'
import { StateOrgView } from '@/features/state/StateOrgView'

// ── Top-level page ────────────────────────────────────────────────────────────

export function StatePage() {
  const { orgSlug, workspace: workspaceParam, versionId } = useParams<{ orgSlug?: string; workspace?: string; versionId?: string }>()

  // orgSlug is guaranteed present by the parent OrgLayout route.
  if (!orgSlug) return null
  return <StateOrgView orgSlug={orgSlug} workspaceParam={workspaceParam} defaultVersionId={versionId} />
}
